export interface LoadingStateProps {
  message: string;
}

export function LoadingState({ message }: LoadingStateProps): React.JSX.Element {
  return (
    <div className="flex items-center justify-center py-12">
      <p className="text-muted-foreground">{message}</p>
    </div>
  );
}
